module.exports = __webpack_public_path__ + "static/marchi-bio-dbc629f6b982bcd25d5fb4e2b215c766.jpg";